import { CondicaoComercialType, ValorFaturaType } from "../@types/financeiro";
import { Token } from "../utils/localStorage.util";
import axios, {
  AxiosError,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from "axios";
import config from "../config.js";

const apiFinanceiro = axios.create({
  baseURL: config.REACT_APP_HOST_API_FINANCEIRO,
});

apiFinanceiro.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    const token = Token.getToken();
    if (token) {
      config.headers.Authorization = token;
    }

    if (!config.headers["Content-Type"]) {
      config.headers["Content-Type"] = "application/json";
    }

    return config;
  },
  (error: AxiosError) => {
    Promise.reject(error);
  }
);

apiFinanceiro.interceptors.response.use(
  (response: AxiosResponse) => {
    return response.data;
  },

  async function (error: AxiosError) {
    if (error?.code === "ERR_NETWORK") {
      return;
    }

    return Promise.reject(error);
  }
);

export function buscarTodasCondicoesComerciais() {
  return apiFinanceiro.get(`/condicao-comercial/`);
}

export function buscarCondicoesComerciaisPorGrupoEconomico(
  idGrupoEconomico: number
) {
  return apiFinanceiro.get(
    `/condicao-comercial/grupo-economico/${idGrupoEconomico}`
  );
}

export function cadastrarCondicaoComercial(
  condicaoComercial: CondicaoComercialType
) {
  return apiFinanceiro.post(`/condicao-comercial/`, condicaoComercial);
}

export function atualizarCondicaoComercial(
  condicaoComercial: CondicaoComercialType,
  idCondicaoComercial: number
) {
  return apiFinanceiro.put(
    `/condicao-comercial/${idCondicaoComercial}`,
    condicaoComercial
  );
}

export function excluirCondicaoComercial(idCondicaoComercial: number) {
  return apiFinanceiro.delete(`/condicao-comercial/${idCondicaoComercial}`);
}

export function obterCondicaoPorTextoDeBusca(
  texto: string,
  idGrupoEconomico: number
) {
  if (idGrupoEconomico) {
    return apiFinanceiro.get(
      `/condicao-comercial/buscar-por-campos?textoDeBusca=${encodeURIComponent(texto)}&idGrupo=${encodeURIComponent(idGrupoEconomico)}`
    );
  } else {
    return apiFinanceiro.get(
      `/condicao-comercial/buscar-por-campos?textoDeBusca=${encodeURIComponent(texto)}`
    );
  }
}

export function buscarValoresFatura(idEmpresa: number) {
  let url = `/valores-fatura/`;
  if (idEmpresa) url += `${idEmpresa}`
  return apiFinanceiro.get(url);
}

/*export function buscarCondicoesComerciaisPorGrupoEconomico(
  idGrupoEconomico: number
) {
  return apiFinanceiro.get(
    `/condicao-comercial/grupo-economico/${idGrupoEconomico}`
  );
}*/

export function cadastrarValoresFatura(idEmpresa: number, valorFatura: ValorFaturaType) {
  return apiFinanceiro.post(`/valores-fatura/${idEmpresa}`, valorFatura);
}

export function atualizarValoresFatura(
  idEmpresa: number,
  idFinanceiroValorFatura: number,
  valorFatura: ValorFaturaType
) {
  return apiFinanceiro.put(
    `/valores-fatura/${idEmpresa}/valor/${idFinanceiroValorFatura}`,
    valorFatura
  );
}

export function excluirValoresFatura(idEmpresa: number ,idFinanceiroValorFatura: number) {
  return apiFinanceiro.delete(`/valores-fatura/${idEmpresa}/valor/${idFinanceiroValorFatura}`);
}

export function obterValoresFaturas() {
  return apiFinanceiro.get(`/valores-fatura/`);
}

export function obterValoresFaturasPorCampo(
  idEmpresa: number,
  textodebusca: string
) {
  return apiFinanceiro.get(
    `/valores-fatura/${idEmpresa}/buscar-por-campos?textoDeBusca=${encodeURIComponent(textodebusca)}`
  );
}

export function buscarFaturamentosPorGrupoEconomico(idGrupoEconomico: number) {
  return apiFinanceiro.get(`/faturamento/${idGrupoEconomico}`);
}

export function obterFaturasPorCampo(
  textodebusca: string,
  idGrupoEconomico: number
) {
  if (!idGrupoEconomico) {
    return apiFinanceiro.get(
      `/faturamento/buscar-por-campos?textoDeBusca=${encodeURIComponent(textodebusca)}`
    );
  } else {
    return apiFinanceiro.get(
      `/faturamento/buscar-por-campos?textoDeBusca=${encodeURIComponent(textodebusca)}&idGrupoEconomico=${encodeURIComponent(idGrupoEconomico)}`
    );
  }
}

export default apiFinanceiro;
